import styled from 'styled-components';

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  align-self: stretch;
`;

export const ContainerTxt = styled.div`
  display: flex;
  width: 490px;
  padding: 16px 16px 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

export const TitleHeader = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);

  /* Title/Title Medium/Semibold | 600 */
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 133.333% */
  letter-spacing: var(--Headline-Small-Tracking, 0);
`;

export const ContainerBody = styled.div`
  display: flex;
  padding: 0px 5px;
  gap: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const TitleBody = styled.span`
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  align-self: stretch;

  /* Label/Label Large/Regular | 400 */
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.014px;
`;

export const ContainerBalance = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid #ededed;
  padding-bottom: 12px;
`;

export const TextBalance = styled.span`
  align-self: stretch;
  color: var(--Takeat-Colors-Neutrals-Black-01, #222);
  margin-left: 28px;

  /* Label/Label Medium/Medium | 500 */
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.5px;
`;

export const InfoBalance = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;
`;

export const FooterBalance = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`;
